import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { NewCollabItemForm } from 'components/NewCollabItemForm/NewCollabItemForm'
import { TodoFormValues } from 'components/TodoForm/Types'
import { observer } from 'mobx-react-lite'
import { useDocStore } from 'stores/DocStore'

export interface Props {
  onActiveChange: (elevated: boolean) => void
  active?: boolean
}

const NewCollabItemFormWrapper = observer(({ active = false, onActiveChange }: Props) => {
  const docStore = useDocStore()

  const onSubmitComment = async (comment: string, mentionedUserIds: number[]) => {
    try {
      await docStore.rootStore.comments.create(
        { comment, commentable_id: docStore.articleId, commentable_type: 'Article', layer_id: docStore.layerId },
        mentionedUserIds,
        true,
      )
    } catch (error) {
      if (error instanceof Error) showToastMessage(error.message, 'error')
    }
  }

  const onSubmitTodo = async (values: TodoFormValues, mentionedIds: number[]) => {
    try {
      await docStore.rootStore.todos.create(
        docStore.articleId,
        { ...values, assigneeId: values.assignee?.id, mentionedIds },
        true,
      )
    } catch (error) {
      if (error instanceof Error) showToastMessage(error.message, 'error')
    }
  }

  return (
    <NewCollabItemForm
      onSubmitComment={onSubmitComment}
      onSubmitTodo={onSubmitTodo}
      onActiveChange={onActiveChange}
      active={active}
    />
  )
})

export { NewCollabItemFormWrapper }
